import ReactGA from "react-ga";

export default function trackPageView(title) {
    ReactGA.pageview(window.location.pathname + window.location.search, [], title);
}
